import * as Immutable from 'immutable';
// import debug from '../../services/debug';

import {
  SET_ADMIN_TAB_REQUESTED,
  SET_ADMIN_TAB_COMPLETED,
  RESET_ADMIN_TAB_REQUESTED,
  RESET_ADMIN_TAB_COMPLETED,
} from '../../actions/adminTab/types';

const schema = {
  resettingTab: false,
  settingTab: false,
  setTab: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMIN_TAB_REQUESTED:
      return state.set('settingTab', true);

    case SET_ADMIN_TAB_COMPLETED:
      return state.set('setTab', true).set('settingTab', false);

    case RESET_ADMIN_TAB_REQUESTED:
      return state.set('resettingTab', true);

    case RESET_ADMIN_TAB_COMPLETED:
      return state
        .set('settingTab', false)
        .set('resettingTab', false)
        .set('setTab', false);

    default:
      return state;
  }
};
export { initialState };

export default reducer;
